import React from 'react';
import LogoImage from '../../assets/images/logo.svg';
import './styles.less';

const RotatePlaceholder = () =>
    <div className="rotate-placeholder">
        <img style={{width:300}} src={LogoImage} />
        <p>PLEASE ROTATE YOUR PHONE<br/>TO PORTRAIT MODE</p>
    </div>
export default RotatePlaceholder;


// WEBPACK FOOTER //
// ./components/Pages/RotatePlaceholder.js